import React, { useEffect, useCallback, useState } from 'react';
import { sendMobileTermAlarmTalk } from '@store/actions/appListAction';
import { useDispatch } from 'react-redux';

import SatButton from '@components/common/satUI/SatButton';

const SendMobileTermAlarmTalkPopup = props => {
  const { applicationNo, ownerName, setBizModal } = props;

  const dispatch = useDispatch();

  const [apiResult, setApiResult] = useState({});

  useEffect(() => {
    handlerSendAlarmTalk(applicationNo);
  }, [applicationNo]);

  //리스트 조회
  const handlerSendAlarmTalk = useCallback(
    applicationNo =>
      dispatch(
        sendMobileTermAlarmTalk({
          applicationNo: applicationNo,
          callback: handlerSendAlarmTalkCallback,
        }),
      ),
    [],
  );

  const handlerSendAlarmTalkCallback = (isSuccess, errorMsg) => {
    setApiResult({ isSuccess: isSuccess, errorMsg: errorMsg });
  };

  // 팝업 닫기
  const closePopup = () => {
    setBizModal({
      visible: false,
    });
  };

  const contRender = apiResult => {
    if (apiResult?.isSuccess) {
      return (
        <p className="layer-text text-center">
          계약자 {ownerName}님에게
          <br />
          약관이 알림톡으로 재발송 되었어요.
        </p>
      );
    } else {
      return <p className="layer-text text-center">{apiResult?.errorMsg}</p>;
    }
  };

  return (
    <>
      <div className="cont">{contRender(apiResult)}</div>
      <div className="box-btns-center">
        <SatButton
          label="확인"
          styleClass="btn-s blue btn-wide"
          onClick={() => closePopup()}
        />
      </div>
    </>
  );
};

export default SendMobileTermAlarmTalkPopup;
